import Vue from 'vue';
import { createHobbitApp } from 'hobbit-base';
import { loadJS } from 'hobbit-base/modules/utils';
import mainHelper from 'hobbit-base/components/bizs/main/main-helper';
// 常用全局通用组件
import AlloyFinger from 'alloyfinger';
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue';
import arms from 'hobbit-engine-base/modules/monitor/arms';
import { extendStatisticsInit } from 'hobbit-engine-base/modules/thirdparty/extendStatistics';
import appView from './app/app.vue'; // App.vue 页面母版
import User from './modules/user'; // 鉴权和用户基本属性相关模块

// eslint-disable-next-line import/no-dynamic-require
const config = require(`../config/${process.env.VUE_APP_RUNTIME}`);

createHobbitApp(
  appView,
  config,
  ({ $hobbit, router }) => {
    const $config = $hobbit.$config;
    const $ctx = $hobbit.$ctx;
    const $fetch = $hobbit.$fetch;
    // #region =#=#=#=#=#=#=#=#=#= 扩展项目级别基础模块 =#=#=#=#=#=#=#=#=#=
    const $user = new User($config, $fetch, $ctx);
    Vue.prototype.$user = $user;
    Vue.use(AlloyFingerPlugin, { AlloyFinger });
    // #endregion

    // #region =#=#=#=#=#=#=#=#=#= 初始化国家和语言、时区 =#=#=#=#=#=#=#=#=#=
    // 计算实时时差
    $ctx.vkTimezone = mainHelper.getVKTimezone();

    // 初始化业务码
    mainHelper.bizInit($hobbit);

    // 引擎配置初始化
    const themeInstalled = mainHelper.themeInstall($hobbit, $ctx.biz);

    // 路由前置校验逻辑初始化
    mainHelper.routerPreCheckInit($hobbit, router, themeInstalled);

    // 初始化代理员信息
    mainHelper.vipAgentInit($hobbit, router);

    // 语言初始化
    mainHelper.langInit($hobbit);
    // #endregion

    // #region =#=#=#=#=#=#=#=#=#= LOG模块初始化 =#=#=#=#=#=#=#=#=#=
    mainHelper.logInit($hobbit, themeInstalled);

    // 统计初始化
    extendStatisticsInit($hobbit, router, themeInstalled);

    // 404错误页初始化
    mainHelper.error404Init($hobbit, router);

    // #region =#=#=#=#=#=#=#=#=#= 监控 =#=#=#=#=#=#=#=#=#=
    arms($hobbit);
    // #endregion

    // 初始化GA
    const GTAG_ID = 'GTM-WF44GHQ2';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    // 注意：请不要将gtag函数定义改变为箭头函数或ES6语法，会导致ga校验不过
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GTAG_ID, { send_page_view: false });
    if (window.top === window && ($hobbit.$ctx.isProd() || $hobbit.$ctx.isPre())) {
      router.afterEach(to => {
        // Gtag的SPA兼容逻辑
        window.gtag('config', GTAG_ID, { page_path: to.path });
      });
      $ctx.onload.then(() => {
        // onload事件的下一个宏任务加载ga，避免阻塞页面
        loadJS(`https://www.googletagmanager.com/gtm.js?id=${GTAG_ID}`, 1e4).catch(error => {
          console.warn('load gtag failed', error);
        });
        // loadJS(`https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`, 1e4).catch(error => {
        //   console.warn('load gtag failed', error);
        // });
      });
    }
    // #endregion

    // #region =#=#=#=#=#=#=#=#=#= Fetch模块初始化 =#=#=#=#=#=#=#=#=#=
    (function initFetch() {
      // 接口请求AOP
      $fetch.hooks.beforeRequest = mainHelper.getDefaultFetchBeforeRequest($hobbit);

      // 接口响应AOP
      $fetch.hooks.afterResponse = response => {
        mainHelper.apiStat(response, $hobbit);

        // 未登录, 如果没指定忽略401，则自动引导登录
        if (response.errorCode === 401 || response.errorCode === 4109) {
          // 删除本地登录态信息
          $user.vkToken(null);
          if (!response.options.preventDefaultAuthCheck) {
            $user.gotoLogin();
          }
        } else if (response.errorCode === 400003) {
          // 拦截临时token，仅可访问有限路由
          window.$hobbit.$app.pageTo(`/website/account/resetpassword/?backurl=${encodeURIComponent(window.location.href)}`);
        }
      };
    }());
    // #endregion

    // #region =#=#=#=#=#=#=#=#=#= 初始化PWA =#=#=#=#=#=#=#=#=#=
    (function initPWA() {
      $ctx.onload.then(() => {
        if ($ctx.view === $ctx.VIEW.PC && !$ctx.isApp()) {
          // 加载manifest
          const manifest = document.createElement('link');
          manifest.rel = 'manifest';
          manifest.href = '/manifest.webmanifest';
          const link = document.getElementsByTagName('link')[0];
          link.parentNode.insertBefore(manifest, link);
          // 监听事件
          window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            $hobbit.$app.setAppData('$PWAInstallPromptEvent', e);
          });
          // 唤起安装弹框
          $ctx.$invokePWAPrompt = async () => {
            const PWAInstallPromptEvent = $hobbit.$app.getAppData('$PWAInstallPromptEvent');
            if (PWAInstallPromptEvent) {
              PWAInstallPromptEvent.prompt();
              const { outcome } = await PWAInstallPromptEvent.userChoice;
              console.log(`user choice: ${outcome}`);
              $hobbit.$app.setAppData('$PWAInstallPromptEvent', null);
              if (outcome === 'accepted') {
                window.$hobbit.$app.pageTo('/school/ucenter/homeroom/');
              }
            }
          };
        }
      });
    }());
    // #endregion

    // #region =#=#=#=#=#=#=#=#=#= 其它杂项初始化 =#=#=#=#=#=#=#=#=#=
    // MOCK配置
    if ($config.fetch.mock) {
      import(/* webpackChunkName: "mocks" */'./mocks').then(mocks => {
        $fetch.mockConfig = mocks.default;
      });
    }

    // 加载调试控制台
    if ($config.site.vconsole && window.top === window && !$ctx.isPC()) {
      loadJS('//s.vipkidstatic.com/fe-static/hobbit/asset/lib/vconsole3.9.min.js').then(() => {
        window.vConsole = new window.VConsole();
      });
    }
    // #endregion
  },
);
